import { render, staticRenderFns } from "./ObservacionesCuotaPopup.vue?vue&type=template&id=55578f56&scoped=true&"
import script from "./ObservacionesCuotaPopup.vue?vue&type=script&lang=js&"
export * from "./ObservacionesCuotaPopup.vue?vue&type=script&lang=js&"
import style0 from "./ObservacionesCuotaPopup.vue?vue&type=style&index=0&id=55578f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55578f56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBadge,
  VBtn,
  VCard,
  VDialog,
  VLayout,
})
